import { render, staticRenderFns } from "./productJFBJ.vue?vue&type=template&id=16f58edf&scoped=true"
import script from "./productJFBJ.vue?vue&type=script&lang=js"
export * from "./productJFBJ.vue?vue&type=script&lang=js"
import style0 from "./productJFBJ.vue?vue&type=style&index=0&id=16f58edf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16f58edf",
  null
  
)

export default component.exports